import { render } from "./StatCard.vue?vue&type=template&id=78aebdac&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=78aebdac&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aebdac"]])

export default __exports__